export enum ArticleTypeEnum {
  Article = 'Article',
  Paragraph = 'Paragraph',
  URL = 'URL',
  YouTube = 'YouTube',
}
